import { AppConfig } from 'config/schema';

let config: AppConfig;

if(process.env.NODE_ENV === 'production') {
    config = require('./prod').default;
} else {
    config = require('./dev').default;
}

export default config;